import { AfterViewInit, Directive, ElementRef, OnInit, inject } from '@angular/core';
import { StylePreferencesService } from '../services/style-preferences.service';

@Directive({
  selector: '[orgbrainHideTabHeader]',
    standalone: false
})
export class HideTabHeaderDirective implements AfterViewInit {
  private element = inject(ElementRef);
  private stylePreferences = inject(StylePreferencesService);

  constructor() {
    console.log('orgbrainHideTabHeader');
  }

  ngAfterViewInit() {
    const labelsList = this.element.nativeElement.getElementsByClassName('mat-mdc-tab-header');

    if (labelsList.length === 1) {
      const el = labelsList[0];
      el.style.display = 'none';
    }
  }
}
